<template>
  <v-layout row wrap>
    <v-flex class="pt-0 pb-3 px-3">
      <v-card class="elevation-0">
      
        <v-container fluid grid-list-md>

          <v-layout row wrap>
            <template v-for="(card, i) in cards">
              <v-flex xs6 sm4 md3 lg2
                class="pa-3"
                :key="i"
                v-if="card.component_path['card_viewable']==undefined?true:card.component_path.card_viewable"
              >
                <v-card class="elevation-0" @click="btn_onClick(card)" style="cursor:pointer;">
                  <v-img
                    :src="card.img_url"
                    width="120px"
                    height="120px"
                    style="margin:auto;"
                    contain
                  ></v-img>
                  <v-card-title primary-title class="justify-center pt-1 pb-1">
                    <center><div class="text-md-center">{{ $t(card.display_text) }}</div></center>
                  </v-card-title>
                </v-card>
              </v-flex>
            </template>

          </v-layout>

        </v-container>
      </v-card>

      <!-- START dialog -->
      <v-dialog v-model="dialog.visible" persistent scrollable max-width="1000px">
        <v-card>
          <v-card-text>
            <v-container fluid class="pa-3">
              <v-layout row wrap>
                <v-flex xs12>
                  <iframe
                    frameborder="0"
                    :src="dialog.iframe_url"
                    width="100%"
                    height="1000px"
                  ></iframe>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" flat @click="dialog.visible = false; dialog.iframe_url=''">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";
import query_builder from "../../functions/query.builder";

export default {
  name: "CardListing_arg",
  // components: {
  //   Breadcrumbs: Breadcrumbs
  // },
  data: () => ({
    username: "",
    cards: [],
    dialog: {
      visible: false,
      iframe_url: "",
    },
    parent_pageID: "",
    rec_order_desc: false
  }),
  mounted: async function() {
    // this.initial();
    this.username = auth.getUsername();
    
    var pageUUID = common.App.get_pageUUID();
    var temp_order = common.App.get_searchParams("orderDesc");

    if (temp_order == "true") {
      this.rec_order_desc = true;
    }

    if (!pageUUID) {
      // arangoDB records
      this.parent_pageID = common.App.getQueryString("_id");  
    } else {
      // django records
      this.parent_pageID = common.App.get_pageID_str(pageUUID);
    }

    var qb = new query_builder.QueryBuilder();
		// qb.Table = "file_upload_listing";
    // qb.Select = [{value:"name"},{value:"g_status_id"}];

    // must check sortBy before push in order array
    qb.Order = [
			{
				name: "order",
				descending: this.rec_order_desc,
			}
		];

    let rule = new query_builder.Rule();
    rule
      .field("parent_page_id")
      .operator(query_builder.A_STR_OPERATOR.EQUAL)
      .value(this.parent_pageID);
    qb.Where.rules.push(rule);

    qb.Offset = 1;

    let res = await common.wBackEndComm.PostData("process_arango_qb_asset/", qb);
		res = res.data;
		if (res.Status == 1) {
      this.cards = res.Body[0].records;

      for (var m in this.cards) {
        var el = this.cards[m];
        el.component_path = el.component_path? JSON.parse(el.component_path): "";
      }
      return this.cards;

      
		} else {
			common.wMsgBox.Error(res.Description);
		}

    
  },
  methods: {
    btn_onClick(data) {
      // var method = data.method__class_name + "-" + data.method__column_name + "-" + data.method__key;
      // common.App.update_pageID(data.id);
      var method = data.method_id;

      switch(method) {
        case "app_selections/122594868":
          window.open(data.path);
          break;
          
        case "app_selections/122594973":
          this.dialog.visible = true;
          this.dialog.iframe_url = data.component_path.iframe_path;
          break;

        default:
          // window.location.href = data.path + "?uuid=" + data.uuid;
          window.location.href = data.path + "?uuid=" + "&orderDesc=" + data.component_path.orderDesc + "&_id=" + data._id;
          // window.open(data.path + "?uuid=" + "&_id=" + data._id, data._id);
      }
    // },
    // onClick_breadcrumb(e){
    //   this.btn_onClick(e);
    }
  }
};
</script>

<style>
</style>
